export function readFileError(error: any): Promise<any> {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.addEventListener('loadend', (e) => {
      resolve((e.target as any).result)
    })
    error.response && reader.readAsText(error.response.data)
  })
}
